import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Route, Switch, Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import dotenv from 'dotenv'

import 'bootstrap/dist/css/bootstrap.css'
import 'react-datepicker/dist/react-datepicker.css'
import './static/css/index.css'

import store from './store'

import withLayout from './helpers/withLayout'

import LoginPage from './pages/login'
import LOBPage from './pages/lob'
import HomePage from './pages/home'
import ConfidentialPage from './pages/confidential'
import StandardPricePage from './pages/standard-price'
import UserPage from './pages/new-employee'
import EmployeeLevelsPage from './pages/employee-levels'
import DepartmentPage from './pages/department'
import DivisionPage from './pages/division'
import PositionPage from './pages/position'
import TeamPage from './pages/team'
import CompanyPage from './pages/company'
import ChangePassword from './pages/change-password'
import MyLeavePage from './pages/my-leave'
import HolidayMasterPage from './pages/public-holiday'
import LeaveEntitlementPage from './pages/leave-entltlement'
import LeaveGenerationPage from './pages/leave-generation'
import LeaveTypePage from './pages/leave-type'
import TeamCalendarPage from './pages/new-team-calendar'
// import NewTeamCalendarPage from './pages/new-team-calendar'
import ClientMasterPage from './pages/client'
import InboxPage from './pages/inbox'
import HeadcountReport from './pages/report/headcount'
import YearOfServiceReport from './pages/report/year-of-service'
import LeaveHistoryReport from './pages/report/leave-history'
import AuditReport from './pages/report/audit-log'
import CompensateWorkReport from './pages/report/compensate-work'
import SubcontractReport from './pages/report/subcontract'
import LeaveGenerationReport from './pages/report/leave-generation'
import ProjectInformationPage from './pages/project-information'
import ProjectPage from './pages/project'
import ProjectCodePage from './pages/project-code'
import TimesheetPage from './pages/timesheet'
import SubcontractCostPage from './pages/subcontract-cost'
import StandardCostAndPricePage from './pages/standard-cost-price'
import EfficiencyResourcePage from './pages/efficiency-resource'
import ProjectProfitSheetPage from './pages/project-profit-sheet'
import SaleProductPage from './pages/sale-product'
import AccountingDashboardPage from './pages/accounting-dashboard'
import ConsentManagementPage from './pages/consent-management'

import * as pps_report from './pages/report/project-profit-sheet'
import * as billingplan_report from './pages/report/billing-plan'
import * as summarytimesheet_report from './pages/report/summary-timesheet'

const history = createBrowserHistory()

dotenv.config()

ReactDOM.render(
  <Provider store={ store }>
    <Router history={ history }>
      <Switch>
        <Route exact path="/" component={ LoginPage } />
        <Route exact path="/change_password" component={ ChangePassword } />

        <Route exact path="/home" component={ HomePage } />
        <Route exact path="/inbox" component={ InboxPage } />
        <Route exact path="/my_leave" component={ MyLeavePage } />
        <Route exact path="/team_calendar" component={ TeamCalendarPage } />
        {/* <Route exact path="/new_team_calendar" component={ NewTeamCalendarPage } /> */}
        <Route exact path="/time_sheet" component={ TimesheetPage } />
        <Route exact path="/time_sheet/approval/:id" component={ TimesheetPage } />
        <Route exact path="/time_sheet/status/:id" component={ TimesheetPage } />
        <Route exact path="/project_information" component={ ProjectPage } />
        <Route exact path="/project_information/:id" component={ ProjectInformationPage } />
        <Route path="/project_profit_sheet" component={ ProjectProfitSheetPage } />
        <Route exact path="/efficiency_resource" component={ EfficiencyResourcePage } />
        <Route exact path="/efficiency_resource/lob/:id" component={ EfficiencyResourcePage } />

        <Route exact path="/accounting_dashboard" component={ AccountingDashboardPage } />
        <Route exact path="/user" component={ UserPage } />
        <Route exact path="/confidential" component={ ConfidentialPage } />
        <Route exact path="/standard_price" component={ StandardPricePage } />
        <Route exact path="/employee_level" component={ EmployeeLevelsPage } />
        <Route exact path="/standard_cost_price" component={ StandardCostAndPricePage } />
        <Route exact path="/subcontract_rate" component={ SubcontractCostPage } />
        <Route exact path="/leave_entitlement" component={ LeaveEntitlementPage } />
        <Route exact path="/leave_generation" component={ LeaveGenerationPage } />
        <Route exact path="/leave_type" component={ LeaveTypePage } />
        <Route exact path="/public_holiday" component={ HolidayMasterPage } />
        <Route exact path="/company" component={ CompanyPage } />
        <Route exact path="/lob" component={ LOBPage } />
        <Route exact path="/department" component={ DepartmentPage } />
        <Route exact path="/position" component={ PositionPage } />
        <Route exact path="/division" component={ DivisionPage } />
        <Route exact path="/team" component={ TeamPage } />
        <Route exact path="/client" component={ ClientMasterPage } />
        <Route exact path="/project_code" component={ ProjectCodePage } />
        <Route exact path="/sale_product" component={ SaleProductPage } />

        <Route exact path="/audit_log" component={ AuditReport } />
        <Route exact path="/leave_history" component={ LeaveHistoryReport } />
        <Route exact path="/headcount_report" component={ HeadcountReport } />
        <Route exact path="/year_of_service" component={ YearOfServiceReport } />
        <Route exact path="/generation_report" component={ LeaveGenerationReport } />
        <Route exact path="/compensate_work_report" component={ CompensateWorkReport } />
        <Route exact path="/subcontract_report" component={ SubcontractReport } />
        <Route exact path="/consent-management" component= { ConsentManagementPage }/>
        <Route path={ pps_report.constants.PATH } component={ withLayout(pps_report.page) } />
        <Route path={ billingplan_report.constants.PATH } component={ withLayout(billingplan_report.page) } />
        <Route path={ summarytimesheet_report.constants.PATH } component={ withLayout(summarytimesheet_report.page) } />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('app')
)



// WEBPACK FOOTER //
// ./src/index.js